/* eslint-disable react/prop-types */
import i18n from "../../../plugins/locale/i18n";
import loadDictionary from "../../../plugins/locale/load-dictionary";
import { Button, Form, ListGroup, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import BankAccountService from "../../../service/bank-account-service";

const bankAccountService = new BankAccountService();

await loadDictionary('bank-account-zero-out-bon-card-window');

function ZeroOutBonCardWindow({isOpenWindow, onCloseWindow, bonCards}) {
    const [tourismBankAccounts, setTourismBankAccounts] = useState([]);
    const [destinationBankAccountId, setDestinationBankAccountId] = useState();
    const [totalBonCardsBalance, setTotalBonCardsBalance] = useState(0);

    const handleClose = (refresh = false) => {
        onCloseWindow(refresh);
    };

    function handleSubmit() {
        bankAccountService.zeroOutBonCards(destinationBankAccountId, bonCards.map(item => item.id))
            .then((response) => {
                if(response.result === "done") {
                    //
                }
            })
            .catch((reason) => {
                console.log(reason);
            })
            .finally(() => {
                handleClose(true);
            });
    }

    useEffect(() => {
        if(!isOpenWindow || !bonCards || Array(bonCards).length === 0) {
            return;
        }

        bankAccountService.findAllByCompany().then(bankAccountOptions => {
            setTourismBankAccounts(bankAccountOptions.filter(bankAccount => bankAccount.bank_id == 2 && bankAccount.type == "bank_account"));
            
        });

        setTotalBonCardsBalance(bonCards.reduce((previousValue, current) => previousValue + current.balance, 0));
    }, [isOpenWindow, bonCards]);

    useEffect(() => {
        setDestinationBankAccountId(tourismBankAccounts[0]?.id);
    }, [tourismBankAccounts]);

    return (
        <Modal show={isOpenWindow} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>{i18n.t("bank-account-zero-out-bon-card-window.title")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form method="POST" id="ZeroOutBonCardForm" onSubmit={e => {e.preventDefault(); handleSubmit();}}>
                    <Form.Group className="mb-3">
                        <Form.Label>{i18n.t("bank-account-zero-out-bon-card-window.destination_bank_account")}</Form.Label>
                        <Form.Select autoFocus value={destinationBankAccountId} onChange={e => {setDestinationBankAccountId(e.target.value)}}>
                            {tourismBankAccounts.map((bankAccount) => <option key={bankAccount.id} value={bankAccount.id}>{bankAccount.name} {bankAccount.account_number}</option>)}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>{i18n.t("bank-account-zero-out-bon-card-window.selected_bon_card_list")}</Form.Label>
                        <ListGroup as="ul" dir="ltr" className="pe-0">
                            {bonCards.map((bonCard) => (<ListGroup.Item as="li" key={bonCard.id} className="d-flex justify-content-between align-items-center"><div className="ms-auto">{bonCard.card_number}</div><div className="">{Number(bonCard.balance).toLocaleString()}</div></ListGroup.Item>))}
                        </ListGroup>
                    </Form.Group>
                </Form>
                <p className="text-info-emphasis fw-bold">{i18n.t("bank-account-zero-out-bon-card-window.total_amount_notice", {amount: totalBonCardsBalance.toLocaleString()})}</p>
                
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>{i18n.t("bank-account-zero-out-bon-card-window.cancel_button")}</Button>
                <Button variant="primary" type="submit" form="ZeroOutBonCardForm" >{i18n.t("bank-account-zero-out-bon-card-window.apply_button")}</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ZeroOutBonCardWindow;